import $ from 'jquery';
import toastr from 'toastr';
import React, { useEffect, useState, useContext, forwardRef } from 'react';
import SessionManager from '../../routes/SessionManager';
import DropdownButton from '../bootstrap4/DropdownButton';
import Activity from './Activity';
import AddActivity from './AddActivity';
import DeleteActivity from './DeleteActivity';
import Modal from '../../components/bootstrap4/Modal';
import Loading from '../Loading'
import bootbox from 'bootbox';
import Input from '../../components/bootstrap4/Input';
import no_image from './../../assets/img/no-image.png';
import Toastr from 'toastr';
import { Context } from '../../views/app';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';
/**
 * 
 * Step.1 : Get Default Template to have default threshold values.
 * Step.2 : Get Zone Activities or SiteSupt Activity Templates.
 * Step.3 : Load first activity by default.
 * 
 */
const ZoneActivities = (props, refs) => {
    const appContext = useContext(Context);
    let user1 = appContext.user;
    let zonesCopy = JSON.parse(JSON.stringify(user1.zones));
    let showAddSettingDialog = false;
    let user = user1;
    let AFTER_HRS_VISITOR_TEMPLATE = "After Hours Visitor Template";

    const [loading, setLoading] = useState(false);
    const [activity_info, setActivityInfo] = useState(null);
    const [activity, setActivity] = useState(null);
    const [zones, setZones] = useState(zonesCopy);
    const [customTemplate, setCustomTemplate] = useState(null);
    const [activityTemplates, setActivityTemplates] = useState(null);
    const [zoneActivities, setZoneActivities] = useState(null);
    const [activityModified, setActivityModified] = useState(null);

    let activity_id = '';
    let selectAxisCamera = true;

    useEffect(() => {
        if (zoneActivities !== null) {
            onActivitySelected();
        }
    }, [zoneActivities]);

    useEffect(() => {
        if (activityModified !== null) {
            isActivityModified();
        }
    }, [activityModified]);

    let isActivityModified = () => {
        function compareJSONObject(O1, O2) {
            var keys1 = Object.keys(O1);
            var keys2 = Object.keys(O2);
            // console.log('Keys Found: ', keys2);
            if (keys1.length === keys2.length && JSON.stringify(keys1.sort()) === JSON.stringify(keys2.sort())) {
                for (var k of keys1) {
                    if ($.isPlainObject(O1[k])) {
                        // console.log('Comparing Object ' + k, [O1[k], O2[k]])
                        return compareJSONObject(O1[k], O2[k]);
                    } else if ($.isArray(O1[k])) {
                        // console.log('Comparing Arrays ' + k, [O1[k], O2[k]])
                        return compareJSONArray(O1[k], O2[k], 'sensor_id');
                    } else {
                        // console.log('Comparing Values ' + k, [O1[k], O2[k]])
                        if (O1[k] !== O2[k]) {
                            // console.log('Values not matching ');
                            return false;
                        }
                    }
                }
            } else {
                // console.log('keys length not matching ');
                return false;
            }
            return true;
        }

        function compareJSONArray(O1, O2, key) {
            if (O1.length === O2.length) {
                let O1New = O1.sort((x, y) => { return x[key] - y[key] });
                let O2New = O2.sort((x, y) => { return x[key] - y[key] });
                for (var k in O1New) {
                    // console.log('Comparing Array Object' + JSON.stringify(k), [O1New[k], O2New[k]]);
                    let result = compareJSONObject(O1New[k], O2New[k]);
                    if (!result)
                        return result;
                }
            } else {
                return false;
            }
            return true;
        }
        let isModified = false;
        if (activity && activityModified) {
            let a = JSON.parse(JSON.stringify(activity));
            let b = JSON.parse(JSON.stringify(activityModified));
            // console.log('a', a);
            // console.log('b', b);

            a.activity_thesh_json = splitMotionThreshold(a);
            b.activity_thesh_json = splitMotionThreshold(b);

            let isNotModified = compareJSONObject(a, b);
            if (isNotModified && (activityModified.activity_id + '').includes('SITESUPT')) {
                isModified = true;
            } else {
                isModified = !isNotModified;
            }

            if (!isModified) {
                isModified = (getZonesToApplyActivity()).length > 0;
            }

            // console.log('isModified ' + isModified);
        }

        if (isModified) {
            // console.log('Removing prop disabled');
            $('.save_zone_settings').attr('disabled', false);
            $('.reset_zone_settings').attr('disabled', false);
            $('.save_zone_settings').off('click').on('click', saveZoneSettings);
            $('.reset_zone_settings').off('click').on('click', resetZoneSettings);
        } else {
            // console.log('Adding prop disabled');
            $('.reset_zone_settings').attr('disabled', true);
            $('.save_zone_settings').attr('disabled', true);
        }
        return isModified;
    }

    let onThresholdChange = (thresholdModified) => {
        let thresholds = JSON.parse(JSON.stringify(activityModified.activity_thresh_json));
        for (const activity of thresholds) {
            if (activity.sensor_id === thresholdModified.sensor_id) {
                if (!activity.fieldName) {
                    if (thresholdModified.fieldName)
                        delete thresholdModified.fieldName
                }
            }
        }
        let i = 0;
        for (let threshold of thresholds) {
            if (thresholdModified.sensor_id === threshold.sensor_id) {
                let thresholdModifiedCopy = { ...thresholdModified };
                //// console.log('Before : ', JSON.stringify(threshold));
                //// console.log('After : ', JSON.stringify(thresholdModified));
                if (thresholdModifiedCopy.default) {
                    // console.log('Deleted Threshold ... Loading default');
                    let thresoldToLoad = customTemplate.activity_thresh_json.filter((x) => x.sensor_id === threshold.sensor_id);
                    if (thresoldToLoad.length > 0) {
                        thresoldToLoad[0].default = true;
                        // console.log('thresoldToLoad ', JSON.stringify(thresoldToLoad));
                        thresholds[i] = thresoldToLoad[0];
                    } else {
                        thresholdModifiedCopy.default = true;
                        thresholds[i] = thresholdModifiedCopy;
                    }

                } else {
                    thresholds[i] = thresholdModifiedCopy;
                }
            }
            i++;
        }
        activityModified.activity_thresh_json = thresholds;
        isActivityModified();
    }


    let fetchZoneActivities = () => {
        // this.showLoading(loadingMsg);

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: { activity_scope: 0 }
        };

        CommonUtils.ajax(
            {
                url: API.ACTIVITY_THRESHOLDS.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.length > 0) {
                        let activityTemplates = res.data[0];
                        let siteActivities = res.data[1];

                        let currActivity = null;
                        let zoneActivities_info = [];

                        let hasAfterHrsTemplate = false;
                        for (let act of siteActivities) {
                            if (act.activity_name.indexOf(AFTER_HRS_VISITOR_TEMPLATE) === 0)
                                hasAfterHrsTemplate = true;

                            if (act.activity_scope === 0) {
                                if (!Array.isArray(act.activity_thresh_json)) {
                                    act.activity_thresh_json = JSON.parse(act.activity_thresh_json);
                                }

                                //// console.log('Curr ' + activity.activity_id + ', Apply ' + this.activity_id);
                                if (act.activity_id + '' === activity_id + '') {
                                    // console.log('Applying ... ');
                                    currActivity = act;
                                }
                                zoneActivities_info.push(act);
                            }
                        };

                        let defaultTemplate;
                        let superTemplates = [];

                        for (let act of activityTemplates) {
                            if (hasAfterHrsTemplate && act.activity_name.indexOf(AFTER_HRS_VISITOR_TEMPLATE) === 0)
                                continue; // This site has already After Hours Visitor Template, so do not show again.

                            if (act.activity_scope === 0) {
                                if (!Array.isArray(act.activity_thresh_json)) {
                                    act.activity_thresh_json = JSON.parse(act.activity_thresh_json);
                                }

                                if (act.customer_id === 'template') {
                                    act.activity_thresh_json = mergeMotionThreshold(act.activity_thresh_json);
                                    defaultTemplate = act;
                                } else {
                                    superTemplates.push(act);
                                }
                            }
                        }
                        console.log(currActivity);
                        setLoading(false);
                        setActivity(null);
                        setCustomTemplate(defaultTemplate);
                        setActivityTemplates(superTemplates);
                        setZoneActivities(zoneActivities_info);
                    } else {
                        setLoading(false);
                    }
                }
            },
            (res) => {
                setLoading(false);
            }
        );
    }

    let showLoading = (loadingMessage) => {
        setLoading(loadingMessage);
    }

    let mergeMotionThreshold = (activity_thresh_json) => {

        let motionOnWorkThreshold, motionOffWorkThreshold;
        let thresholds = [];

        for (let threshold of activity_thresh_json) {
            if (threshold.sensor_id === 'motion') {
                motionOnWorkThreshold = threshold;
            } else if (threshold.sensor_id === 'motion_ahours') {
                motionOffWorkThreshold = threshold;
            } else {
                thresholds.push(threshold);
            }
        }

        if (motionOnWorkThreshold) {
            if (motionOffWorkThreshold) {
                motionOnWorkThreshold.alert_timeout_off = motionOffWorkThreshold.alert_timeout;
                motionOnWorkThreshold.notify_me_off = motionOffWorkThreshold.notify_me;
            }
            thresholds.push(motionOnWorkThreshold);
        } else if (motionOffWorkThreshold) {
            motionOnWorkThreshold = motionOffWorkThreshold;
            motionOnWorkThreshold.sensor_id = 'motion';
            motionOnWorkThreshold.alert_timeout_off = motionOffWorkThreshold.alert_timeout;
            motionOnWorkThreshold.notify_me_off = motionOffWorkThreshold.notify_me;
            delete motionOffWorkThreshold.alert_timeout;
            delete motionOffWorkThreshold.notify_me;
            thresholds.push(motionOnWorkThreshold);
        }

        let sensor_id_sort_order = ['temperature', 'humidity', 'motion', 'co', 'co2', 'voc', 'vmotion_ahours', 'battbackup'];
        thresholds = thresholds.sort((x, y) => sensor_id_sort_order.indexOf(x.sensor_id) - sensor_id_sort_order.indexOf(y.sensor_id));
        return thresholds;
    }

    let splitMotionThreshold = (activityToSplit) => {
        let thresholdsModified = JSON.parse(JSON.stringify(activityToSplit.activity_thresh_json));
        thresholdsModified = thresholdsModified.filter((t) => !t.default);

        let thresoldsToSave = [];
        let motion_ahours_threshold;
        for (let threshold of thresholdsModified) {
            delete threshold.default;
            if (threshold.sensor_id === 'motion') {
                motion_ahours_threshold = JSON.parse(JSON.stringify(threshold));
                motion_ahours_threshold.sensor_id = 'motion_ahours';
                motion_ahours_threshold.notify_on = 'offwork';
                motion_ahours_threshold.notify_me = motion_ahours_threshold.notify_me_off;
                motion_ahours_threshold.alert_timeout = motion_ahours_threshold.alert_timeout_off;
                delete motion_ahours_threshold.notify_me_off;
                delete motion_ahours_threshold.alert_timeout_off;

                delete threshold.notify_me_off;
                delete threshold.alert_timeout_off;

                thresoldsToSave.push(threshold);
            } else {
                thresoldsToSave.push(threshold);
            }
        }
        if (motion_ahours_threshold)
            thresoldsToSave.push(motion_ahours_threshold);

        return thresoldsToSave;
    }

    let onActivitySelected = (activitySelected, afterSave = false) => {
        let isSaveBtnEnabled = $('.save_zone_settings').length > 0 && !$('.save_zone_settings').attr('disabled');
        if (isSaveBtnEnabled) {
            bootbox.confirm('Would you like to save the changes before you proceed ?', (isYes) => {
                if (isYes) {
                    saveZoneSettings();
                } else {
                    resetActivity();
                }
            });
        } else {
            // let zoneActivities = [...zoneActivities];
            if (afterSave === true) {
                let found = false;
                for (let i = 0; i < zoneActivities.length; i++) {
                    if (String(zoneActivities[i]['activity_id']) === String(activitySelected.activity_id)) {
                        zoneActivities[i] = activitySelected;
                        found = true;
                    }
                }
                if (!found) {
                    zoneActivities.push(activitySelected);
                }
            }

            if (activitySelected === null || activitySelected === undefined) {
                if (zoneActivities && zoneActivities.length > 0) {
                    activitySelected = zoneActivities[0];
                } else {
                    return;
                }
            }

            let activity = { ...activitySelected };

            // Add missing thresholds as defaults.
            let thresholdsFound = [];
            if (!$.isArray(activity.activity_thresh_json)) {
                activity.activity_thresh_json = JSON.parse(activity.activity_thresh_json);
            }

            for (let t of activity.activity_thresh_json) {
                thresholdsFound.push(t.sensor_id);
            }
            //// console.log('customTemplate', customTemplate);
            var defaultThresholds = [];
            if (customTemplate) {
                defaultThresholds = JSON.parse(JSON.stringify(customTemplate.activity_thresh_json));
            }

            //// console.log('DefaultThresholds', defaultThresholds);
            //// console.log('ActivityThresholds', activity.activity_thresh_json);

            for (let t of defaultThresholds) {
                if (thresholdsFound.indexOf(t.sensor_id) === -1) {
                    let tDefault = { ...t };
                    tDefault.default = true;
                    activity.activity_thresh_json.push(tDefault);
                }
            }

            activity.activity_thresh_json = mergeMotionThreshold(activity.activity_thresh_json);
            // console.log('activity - After Defaults added', activity);
            updateActivityState(activity, zoneActivities);
        }
    }

    let updateActivityState = (activity, zoneActivity = zoneActivities) => {
        if (activity) {
            let activity_info = {};
            for (let k of ['activity_name', 'activity_desc']) // To track activity info separately.
                activity_info[k] = activity[k];
            let activityModify = JSON.parse(JSON.stringify(activity));
            setActivityModified(activityModify);
            setLoading(false);
            setZoneActivities(zoneActivity);
            setActivity(JSON.parse(JSON.stringify(activity)));
            setActivityInfo(activity_info);
            setZones(JSON.parse(JSON.stringify(user1.zones)));
            if ((activityModify.activity_id + '').includes('SITESUPT')) {
                isActivityModified();
            }
        } else {
            setLoading(false);
            setZoneActivities(zoneActivity);
            setActivity(null);
            setActivityInfo(null);
            setZones(JSON.parse(JSON.stringify(user1.zones)));
        }

        if (showAddSettingDialog) {
            showAddSettingDialog = false;
            confirmBeforeSelectSettings();
        }

    }

    let toggleSelection = (z, k) => {
        let activity_id = activity.activity_id;
        let zones1 = [...zones];

        let activity_id_new = (activity_id + "");
        if (z.location_activity) {
            let activities = z.location_activity.split(':');
            if (activities.indexOf(activity_id_new) !== -1) {
                activities = activities.filter((x) => x !== activity_id_new && x.trim() !== '' && x !== undefined);
            } else {
                activities.push(activity_id_new);
            }
            z.location_activity = activities.sort().join(':');
        } else {
            z.location_activity = activity_id_new;
        }

        //// console.log('After Checkbox change ', z.location_activity);
        //// console.log('After Checkbox change - user ', user1.zones[k].location_activity);

        zones1[k] = z;
        setZones(zones1);
        isActivityModified();
    }

    let onActivityInfoChange = (e) => {
        let target = $(e.target);
        let attribute = target.attr('name');
        let activity_info_new = { ...activity_info };
        //// console.log('attribute ', attribute);
        activity_info_new[attribute] = target.val();
        let activity = { ...activityModified }
        activity[attribute] = target.val();
        setActivityModified(activity);
        setActivityInfo(activity_info_new);
    }

    let getClassNameForZone = (z) => {
        let zoneClassName = "far fa-lg text-primary fa-square";
        if (z.location_activity) {
            let activity_id = activity.activity_id + '';
            let zoneActivities = z.location_activity.split(':');
            //// console.log('activity_id ' + activity_id + ', Zone Activity: ' + z.location_activity + ', zoneActivities.indexOf(activity_id) : ' + (zoneActivities.indexOf(activity_id)));
            if (zoneActivities.indexOf(activity_id) !== -1) {
                zoneClassName = "fa fa-lg text-primary fa-check-square";
                let selectedZone = zones.filter((zone) => (zone.location_activity && zone.location_activity.split(':').indexOf(activity_id) !== -1));
                for (const axis of selectedZone) {
                    if (!axis.location_device_type) {
                        selectAxisCamera = true;
                        break
                    } else {
                        //selectAxisCamera = false;
                    }
                }
            }
        }
        return zoneClassName;
    }

    let resetActivity = () => {
        activity_id = activity ? activity.activity_id : null;
        setActivity(null);
        setActivityInfo(null);
        setZones(JSON.parse(JSON.stringify(user1.zones)));
        fetchZoneActivities('');
    }

    let resetZoneSettings = () => {
        bootbox.dialog({
            message: "Are you sure you want to reset the changes ?",
            buttons: [
                { className: 'btn btn-sm btn-default w-50', callback: () => { }, label: 'No' },
                { className: 'btn btn-sm btn-primary w-50', callback: () => { resetActivity(); }, label: 'Yes' }]
        })
    }

    let getZonesToApplyActivity = () => {
        let zonesNow = [...zones];
        let zonesBefore = [...user.zones];
        let zonesToApplyActivity = [];
        for (let i = 0; i < zonesNow.length; i++) {
            if ((zonesNow[i] && zonesNow[i].location_activity ? zonesNow[i].location_activity.trim() : '') !== (zonesBefore[i] && zonesBefore[i].location_activity ? zonesBefore[i].location_activity.trim() : '')) {
                zonesToApplyActivity.push({ ...zonesNow[i] });
                // console.log('ZoneActivitiy Change Detected ', zonesToApplyActivity)
            }
        }
        return zonesToApplyActivity;
    }

    let captureAfterVisitorEnabledZones = (zone_map) => {

        let site_security_lss = user.site_selected.site_security_lss || { active: false, notify_on: 'offwork' };
        site_security_lss.zone_map = zone_map;

        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            user_type: 'user',
            form_input: {
                customer_id: user.site_selected.customer_id,
                site_id: user.site_selected.site_id,
                site_security_lss: site_security_lss
            }
        };

        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.SITE.MODIFY_ALT,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code !== 200) {
                    Toastr.error('An error occured ...please try again.', 'Error');
                    return;
                } else {
                    let siteObj = user.site_selected;
                    siteObj.site_security_lss = site_security_lss;

                    var sessionMgr = new SessionManager();
                    let userU = sessionMgr.readCookie("user");
                    userU.site_selected = siteObj;
                    user.site_selected = siteObj;

                    sessionMgr.storeCookie('user', userU);
                }
            },
            (res) => {
                console.log('An error occured while saving zonemap into site.');
            });
    }

    let saveZoneSettings = () => {
        // console.clear();
        // console.log('Saving Zone Settings ....');

        // Step.1 Save Threshold
        // Step.2 Apply threshold to any new zones added.
        if (activityModified.activity_name === "") {
            return Toastr.error("Activity name should not be empty");
        }
        let activity = zoneActivities.filter((name) => name.activity_id !== activityModified.activity_id);
        let currActivity = activity.find((name) => name.activity_name === activityModified.activity_name);
        if (currActivity) {
            return Toastr.error("Activity name should not be same");
        }

        var commonData = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id
        };
        var data = { ...activityModified };
        //// console.log('thresholds before split', data.activity_thresh_json);
        data.activity_thresh_json = splitMotionThreshold(data);

        const thresholdsModified = data.activity_thresh_json
        for (let threshold of thresholdsModified) {

            if (!threshold.default) {
                if (threshold.inputValidation && !threshold.inputValidation.isvalidtext) {

                    const position = toastr.options.positionClass
                    toastr.options.positionClass = 'toast-top-center';
                    toastr.error(threshold.inputValidation.invaliderrormsg)
                    toastr.options.positionClass = position;
                    return
                }
                else if (threshold.sensor_id && (threshold.sensor_id.toLowerCase().includes("temperature") || threshold.sensor_id.toLowerCase().includes("humidity"))) {
                    if (!(Number(threshold.alert_down) < Number(threshold.alert_up))) {

                        const position = toastr.options.positionClass
                        toastr.options.positionClass = 'toast-top-center';
                        toastr.error(threshold.sensor_id + " : Drops below should be lower than rises above.")
                        toastr.options.positionClass = position;
                        return
                    }
                }
            }
        }

        showLoading('Saving details ...');
        for (let t of data.activity_thresh_json) {
            if (t.alert_timeout) {
                try {
                    t.alert_timeout = parseInt(t.alert_timeout);
                } catch (error) {
                    t.alert_timeout = 180;
                }
            }
            if (t.notify_me) {
                try {
                    t.notify_me = t.notify_me === 'true' || t.notify_me === true ? true : false;
                } catch (error) {
                }
            }

        }

        data.activity_thresh_json = JSON.stringify(data.activity_thresh_json);
        data.activity_thresh = data.activity_thresh_json;
        //// console.log('thresholds after split ...', data.activity_thresh_json);

        data.activity_scope = 0;
        data.site_id = user.site_selected.site_id;
        data.customer_id = user.customer_id;

        let activity_id_old = data.activity_id + '';
        if (activity_id_old.includes('SITESUPT')) {
            delete data.activity_id;
        }
        let zonesToApplyActivity = getZonesToApplyActivity();
        // console.log('data.activity_id : ' + data.activity_id);
        var operation = !data.activity_id || data.activity_id === 0 ? 'add' : 'modify';
        let payload = { ...commonData };
        payload.form_input = data;

        CommonUtils.ajax(
            {
                url: API.ACTIVITY_THRESHOLDS.BASE + API.PATH_SEPARATOR + operation,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(payload)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    // console.log('RESPONSE ', res.data);
                    let activityAfterSaving = res.data.activity;

                    let steps = zonesToApplyActivity.length > 0 ? 2 : 1;
                    let activity_id_new = activityAfterSaving.activity_id;

                    data.activity_id = activity_id_new;
                    activity_id = activity_id_new; // Use this to pre-populate

                    if (steps === 1) {
                        onActivitySelected(activityAfterSaving, true);
                        Toastr.success("Zones specific alerts saved successfully !");
                    }

                    if (zonesToApplyActivity.length > 0) {
                        linkOrDelinkZoneActivity(data.activity_id, activity_id_old, 1, zonesToApplyActivity, function (zonesModified) {
                            // console.log('zonesModified ', zonesModified);

                            if (data.activity_name.indexOf(AFTER_HRS_VISITOR_TEMPLATE) === 0) {
                                let zoneMap = {};
                                let ctr = 0;
                                for (let z of zonesModified) {
                                    if (z.location_activity && z.location_activity.split(':').includes(String(data.activity_id))) {
                                        zoneMap[z.location_id] = ++ctr;
                                    }
                                }
                                captureAfterVisitorEnabledZones(zoneMap);
                            }

                            if (zonesModified.length > 0) {
                                user.zones = zonesModified;
                                appContext.updateUser(user);
                                setZones(zonesModified);
                                onActivitySelected(activityAfterSaving, true);
                                Toastr.success("Site info saved successfully !");
                            } else {
                                onActivitySelected(activityAfterSaving, true);
                            }
                        });
                    }

                }
            },
            (res) => {
            });

    }

    let linkOrDelinkZoneActivity = (activity_id, activity_id_old, linkOrDelink, zonesToModify, cb) => {
        var commonData = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id
        };

        let zonesToApplyActivityPromises = [];
        for (let z of zonesToModify) {
            let dataZ = { ...commonData };
            let zoneToSave = {};
            zoneToSave.site_id = commonData.site_id;
            zoneToSave.location_id = z.location_id;

            let activities = z.location_activity.split(':');
            // console.log('activity_id_new : ' + activity_id + ' activity_id_old : ' + activity_id_old);

            if (activity_id + '' !== activity_id_old + '') {
                activities = activities.filter((a) => a.trim() !== '' && a !== '0' && !a.includes('SITESUPT') && a !== undefined);
                if (activity_id !== undefined)
                    activities.push(activity_id);
            } else {
                // console.log('Activities Before ' + activities);
                activities = activities.filter((a) => {
                    if (a.trim() !== '' && a !== '0' && a !== undefined) {
                        if (linkOrDelink === 0 && a.trim() === activity_id + ''.trim()) {
                            return false;
                        }
                        return true; // add whatever comes incase of 1
                    }
                    return false;
                });

                // console.log('Activities After ' + activities);
            }

            zoneToSave.location_activity = activities.length > 0 ? activities.sort().join(':') : '';
            if (zoneToSave.location_activity === '') {
                zoneToSave.location_activity = ' ';
            }

            //// console.log('Zone ID ' + z.location_id + ', Zone Activity ' + z.location_activity + ', Length ' + z.location_activity.length);
            dataZ.form_input = zoneToSave;
            zonesToApplyActivityPromises.push(applyActivitytToZonePromise(dataZ));
        }

        if (zonesToApplyActivityPromises.length === 0) {
            cb([]);
        } else {
            Promise.all(zonesToApplyActivityPromises).then(locs => {
                let zoneMap = {};
                for (var loc of locs) {
                    zoneMap[loc.location_id] = loc;
                }
                let zonesNow = JSON.parse(JSON.stringify(zones));
                for (let zone of zonesNow) {
                    if (zoneMap[zone.location_id]) {
                        zone.location_activity = zoneMap[zone.location_id].location_activity;
                    }
                }
                cb(zonesNow);
            });
        }

    }

    let onConfirmDelete = (activity_id) => {
        let fileName = activity.activity_name;
        let zonesToModify = zones.filter((z) => z.location_activity && z.location_activity.split(':').indexOf(activity_id + '') !== -1);
        linkOrDelinkZoneActivity(activity_id, activity_id, 0, zonesToModify, function (zonesModified) {
            var payload = {
                user_login: user.user_login,
                user_token: user.user_token,
                site_id: user.site_selected.site_id,
                customer_id: user.customer_id,
                form_input: { activity_id: activity_id }
            };
            CommonUtils.ajax(
                {
                    url: API.ACTIVITY_THRESHOLDS.DELETE,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(payload)
                }
            ).then(
                (res) => {
                    if (res.status && res.status.code === 200) {
                        if (zonesModified.length > 0) {
                            setZones(zonesModified);
                            user.zones = zonesModified;
                            var sessionManager = new SessionManager();
                            sessionManager.storeCookie(
                                'user',
                                { ...user }
                            );
                            Toastr.success("Deleted Successfully");
                            showLoading('Deleting ' + fileName + ' ...');
                            fetchZoneActivities();
                        } else {
                            Toastr.success("Deleted Successfully");
                            showLoading('Deleting ' + fileName + ' ...');
                            fetchZoneActivities();

                        }
                    }
                },
                (res) => {

                });
        });
    }

    let applyActivitytToZonePromise = (data) => {
        return new Promise((resolve, reject) => {
            // console.log('Ajax: Saving Activity To Zone ', data);
            CommonUtils.ajax(
                {
                    url: API.LOCATION.MODIFY,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    resolve(data.form_input);
                },
                (res) => {
                    reject(data.form_input);
                });
        });
    }

    let confirmBeforeSelectSettings = () => {
        let isSaveBtnEnabled = $('.save_zone_settings').length > 0 && !$('.save_zone_settings').attr('disabled');
        if (isSaveBtnEnabled) {

            bootbox.dialog({
                message: "Would you like to save your changes before you proceed to add new ? ",
                buttons: [
                    { callback: () => { $('.add-zone-settings').trigger('click'); $('.save_zone_settings').attr('disabled', true); }, label: 'No' },
                    { callback: () => { saveZoneSettings(); showAddSettingDialog = true; }, label: 'Yes' }
                ]
            })
        } else {
            $('.add-zone-settings').trigger('click');
        }
    }

    let checkAllZones = () => {
        var zones1 = [...zones];
        for (var zone of zones1) {
            zone.location_activity = zone.location_activity && zone.location_activity.trim().length > 0 ? zone.location_activity + ":6SITESUPT" : "6SITESUPT"
        }
        setZones(zones1);
    }

    React.useImperativeHandle(refs, () => ({
        showLoading,
        fetchZoneActivities,
        isActivityModified,
        saveZoneSettings
    }));

    let deleteButtonCSS = (activity && activity.activity_id && (activity.activity_id + '').includes('SITESUPT')) ? 'hide' : 'btn btn-sm btn-danger btn-border-1 mr-2';
    let isAfterHrsTemplate = activity_info && activity_info.activity_name.indexOf(AFTER_HRS_VISITOR_TEMPLATE) === 0;

    return (
        <React.Fragment >
            {loading && <Loading>{loading}</Loading>}
            {!loading && zoneActivities &&
                <div className='row mb-4'>
                    <div className='col-md-6'>
                        {zoneActivities.length > 0 ?
                            <React.Fragment>
                                <label className='pr-2'>Select To Edit :</label>
                                <DropdownButton
                                    className='btn btn-sm dropdown-toggle text-dark'
                                    onOptionClick={onActivitySelected}
                                    default={activity ? activity.activity_name : 'Choose Zone Setting'}
                                    selected={activity ? activity.activity_id : ''}
                                    opts={zoneActivities}
                                    field_attr='activity_id'
                                    value_attr='activity_name' />
                            </React.Fragment>
                            :
                            activity ? '' : <span className='text-app'><i className="fa fa-warning text-warning"></i> No Zone Settings found ...</span>
                        }
                    </div>
                    <div className="col-md-6 text-md-right">
                        {!loading &&
                            <React.Fragment>
                                <button className="btn btn-sm btn-success btn-border-1 mr-2" data-toggle="tooltip" onClick={confirmBeforeSelectSettings}>Add</button>
                                <Modal title="Select Settings Template" ref={React.createRef()} id="selectSettingsModal" label={<button className="btn hide btn-sm btn-primary btn-border-1 ml-2 add-zone-settings" data-toggle="tooltip"><i className="fa fa-plus"></i></button>} size="modal-md">
                                    <AddActivity title="Select Settings Template" activityTemplates={activityTemplates} customTemplate={customTemplate} onActivitySelected={onActivitySelected} checkAllZones={checkAllZones}></AddActivity>
                                </Modal>
                            </React.Fragment>
                        }

                        {activity &&
                            <span>
                                <button className="btn btn-sm btn-light btn-border-1 mr-2 reset_zone_settings" disabled={true} onClick={resetZoneSettings}>Cancel</button>

                                <Modal title="Confirmation" ref={React.createRef()} id="deleteSettingsModal" label={<button className={deleteButtonCSS}> Delete</button>} size="modal-md">
                                    <DeleteActivity title="Confirmation" activity={activity} onConfirmDelete={onConfirmDelete}></DeleteActivity>
                                </Modal>

                                <button className="btn btn-sm btn-primary btn-border-1 save_zone_settings" disabled={true} onClick={saveZoneSettings}>Save</button>
                            </span>
                        }

                    </div>
                </div>
            }

            {
                !loading && activity && activity_info &&
                <React.Fragment>
                    <div className="card border border-0 bg-light border-light">
                        <div className='card-header p-0'>
                            <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                                {activity_info.activity_name}
                            </div>
                        </div>
                        <div className="card-body bg-white border-0">
                            <div className="row">
                                <div className="col-md-12">
                                    <table width="100%">
                                        <tbody>
                                            <tr>
                                                <td width="100px"><label>Name : </label></td>
                                                <td>
                                                    <Input type={isAfterHrsTemplate ? "hidden" : "text_no_regex"} name="activity_name" maxLength="100" onChange={onActivityInfoChange} className="form-control width-100-perc" value={activity_info.activity_name}></Input>
                                                    {isAfterHrsTemplate && activity_info.activity_name}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="100px"><label>Description : </label></td><td><textarea type="text" name="activity_desc" maxLength="1024" onChange={onActivityInfoChange} className="form-control width-100-perc" value={activity_info.activity_desc}></textarea></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2" className="pt-5"><label>Select Zone(s)</label></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">
                                                    <div className="row">
                                                        {
                                                            zones && zones.map((z, k) => (
                                                                <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2" key={k}>
                                                                    <img onError={(e) => e.target.src = no_image} className="img-fluid border-light border-rounded-t cursor-pointer" src={z.image} alt={z.location_name} onClick={(e) => toggleSelection(z, k)} />
                                                                    <div role="group" className="bg-light py-1 border-rounded-b" onClick={(e) => toggleSelection(z, k)}>
                                                                        <span className="p-2"><i className={getClassNameForZone(z)}></i></span>
                                                                        <span className="mt-2 font-size-12"><span data-toggle="tooltip" data-placement="bottom" title={z.location_name.length > 12 ? z.location_name : ''}>{z.location_name.length > 12 ? z.location_name.substring(0, 12) + '..' : z.location_name}</span></span>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {
                            activityModified !== null &&
                            <div className="card-footer bg-white border-0 p-1">
                                <Activity activity={activity} onChange={onThresholdChange} refresh_id={new Date().getUTCMilliseconds()} showClimate={selectAxisCamera}></Activity>
                            </div>
                        }
                    </div>
                </React.Fragment>
            }

        </React.Fragment >
    );
}

export default forwardRef(ZoneActivities);